module.exports = __webpack_public_path__ + "images/logo-kindyroo.4ab6733520e362a42bf2305b1d1a5eb1.png";